import { render, staticRenderFns } from "./ResumoOrdensServicos.vue?vue&type=template&id=4789a5fb&"
import script from "./ResumoOrdensServicos.vue?vue&type=script&lang=js&"
export * from "./ResumoOrdensServicos.vue?vue&type=script&lang=js&"
import style0 from "./ResumoOrdensServicos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports